import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Toolbar from "../../../components/toolbar/Toolbar";
import { Column } from "primereact/column";
import { routes } from "../../../constants";
import { Page } from "../../../components/page/Page";
import { PolicesResourcesList } from "./PolicesResourcesList";
import { actions } from "../policesResources.actions";
import { AppService, COMPANY_CHANGE_EVENT_NAME, BUSINESS_UNIT_CHANGE_EVENT_NAME } from "../../../services/app.service";

const mapStateToProps = (state) => {
  return {
    columns: state.crudPolicesResourcesState.columns,
    records: state.crudPolicesResourcesState.records,
    first: state.crudPolicesResourcesState.index,
    rows: state.crudPolicesResourcesState.max,
    totalRecords: state.crudPolicesResourcesState.count,
    sortField: state.crudPolicesResourcesState.sortField,
    order: state.crudPolicesResourcesState.sortOrder,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) =>
      dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null));
      dispatch(actions.applyFilter(filterParams));
    },
    load: () => {
      dispatch(actions.load());
    },
    setSelectedRecords: (selectedRecords) => {
      dispatch(actions.setSelectedRecords(selectedRecords));
    },
  };
};

class PolicesResourcesListPageContainer extends React.Component {
  newHandler = () => {
    this.props.history.push(`${routes.PATH_POLICES_RESOURCES}/novo`);
  };

  componentDidMount() {
    this.props.load();
    AppService.on(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.on(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }
  componentWillUnmount() {
    AppService.off(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.off(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }

  onReceiveAppNotifications = (eventName, params) => {
    if (
      eventName === COMPANY_CHANGE_EVENT_NAME ||
      eventName === BUSINESS_UNIT_CHANGE_EVENT_NAME
    ) {
      this.props.applyFilter([]);
    }
  };
  onPage = (e) => {
    this.props.paginate({
      max: e.rows,
      index: e.first,
    });
  };
  onSort = (e) => {
    this.props.sortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField,
    });
  };

  onFilter = (e) => {
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach((key) => {
      console.log("onFilter key=", key)
      if (key == "policeId") {
        filters.push({
          campo: key,
          valor: parseInt(e.filters[key].value),
          tipoFiltro: "IGUAL_A",
        });
      } else {
        filters.push({
          campo: key,
          valor: e.filters[key].value,
          tipoFiltro: "CONTEM",
        });
      }
    });
    this.props.applyFilter(filters);
  };

  onRowClick = (e) => {
    const oid = e && e.data && e.data.oid;
    if (oid) {
      this.props.history.push(`${routes.PATH_POLICES_RESOURCES}/${oid}`);
    }
  };

  render() {
    const header = (
      <div>
        <h1>Politicas-Menu</h1>
        <hr className="lxSplitter"></hr>
        <div>
          <Toolbar
            onNew={this.newHandler}
            newButtonStyle="highlighted"
          ></Toolbar>
        </div>
      </div>
    );

    const columns = this.props.columns.map((col) => {
      if (col.field == "oid") {
        return <Column {...col} key={col.field} style={{ fontSize: "12px", width: "80px" }} />;
      }
      if (col.field == "policeId") {
        return <Column {...col} key={col.field} style={{ fontSize: "12px", width: "110px" }} />;
      }
      return <Column {...col} key={col.field} style={{ fontSize: "12px" }} />;
    });

    const content = (
      <PolicesResourcesList
        {...this.props}
        onRowClick={this.onRowClick}
        onFilter={this.onFilter}
        onPage={this.onPage}
        onSort={this.onSort}
        columns={columns}
      />
    );
    return <Page header={header} content={content} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicesResourcesListPageContainer);
